<div nz-row class="company-intro-image"></div>
<div class="background-circles"></div>
<div class="message-title center-parent" style="height: 380px;">
  <span class="title align-center">조직도</span>
  <p class="content align-center" style="margin-top: 30px;">2006년 설립부터 현재까지 최고의 제품을 제공하여 고객을 만족시키고<br/>
    내실이 탄탄한 기업이 되기위해 끊임없이 발전하며 노력하고 있습니다.</p>
</div>
<div class="organization-chart"></div>
<div class="main-footer" nz-row>
  <p>COPYRIGHT BY (C) 2009 HYUNDAI GREEN TECH ALL RIGHTS RESERVED.<br/>
    [SEOUL]  T 02-2115-8815  F 02-2115-8818  [CHEON-AN] T 041-582-2214, 2215  F 041-588-2215</p>
</div>
